import { Box, Flex, Text } from '@chakra-ui/react'
import SectionStack from 'components/common/SectionStack'
import ExternalLink from 'components/links/ExternalLink'
import { FacebookIcon } from 'components/svg/FacebookIcon'
import { InstagramIcon } from 'components/svg/InstagramIcon'
import { LinkedInIcon } from 'components/svg/LinkedInIcon'
import { YouTubeIcon } from 'components/svg/YouTubeIcon'
import { Body1 } from 'components/typography'
import { useBrandCookie } from 'hooks/helpers/useBrandCookie'
import { FC } from 'react'

export const SOCIAL_LINKS = [
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/omensbr/',
    icon: InstagramIcon
  },
  {
    label: 'Linkedin',
    href: 'https://www.linkedin.com/company/omensbr/',
    icon: LinkedInIcon
  },
  {
    label: 'Youtube',
    href: 'https://www.youtube.com/channel/UCezMA48gBP6RrbXtwovouqA',
    icon: YouTubeIcon
  },
  // {
  //   label: 'TikTok',
  //   href: 'https://www.tiktok.com/@omensbr',
  //   icon: TikTokIcon
  // },
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/omensbrasil/',
    icon: FacebookIcon
  }
]
interface SocialLinksSectionProps {
  fill?: string
}
const SocialLinksSection: FC<SocialLinksSectionProps> = ({ fill }) => {
  const isOmensFit = useBrandCookie('isWeightAddress')

  if (isOmensFit) return null
  return (
    <SectionStack>
      <Text textStyle={{ base: 'body1sm', lg: 'body1' }} pb="4px" borderBottom="2px solid #25241E">
        Siga nas redes
      </Text>
      <Flex wrap="wrap" sx={{ gap: '2rem' }}>
        {SOCIAL_LINKS.map(({ label, href, icon }) => (
          <Body1 key={label} display="flex" alignItems="center" sx={{ gap: '.5rem' }}>
            <ExternalLink href={href}>
              <Box as={icon} fill={fill || 'dandelion'} />
            </ExternalLink>
          </Body1>
        ))}
      </Flex>
    </SectionStack>
  )
}

export default SocialLinksSection
